import { render, staticRenderFns } from "./MessageDisplayer.vue?vue&type=template&id=5891904a&scoped=true"
import script from "./MessageDisplayer.vue?vue&type=script&lang=ts"
export * from "./MessageDisplayer.vue?vue&type=script&lang=ts"
import style0 from "./MessageDisplayer.vue?vue&type=style&index=0&id=5891904a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891904a",
  null
  
)

export default component.exports